module.exports = __webpack_public_path__ + "img/big.16ebfd47.svg";